import { render } from "./TypeSwicth.vue?vue&type=template&id=21164dff&ts=true"
import script from "./TypeSwicth.vue?vue&type=script&lang=ts"
export * from "./TypeSwicth.vue?vue&type=script&lang=ts"

import "./TypeSwicth.vue?vue&type=style&index=0&id=21164dff&lang=css"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__